import { Dtos, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import {
	bondRequestBondFormQueryKey,
	bondRequestLatestUnderwritingQueryKey,
} from "../bond-request.keys";
import { redirectToIssuedBond } from "../utils";

export const useAdminUpdateBondForm = (id: SuretyQuoteId, accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { put } = useRequest();

	const mutation = useMutation({
		meta: { redirectOnError: redirectToIssuedBond },
		mutationKey: ["adminUpdateBondForm", id],
		mutationFn: async (data: Dtos.SuretyBondForm.Update.Request) => {
			return await put(`/v2/admin/surety/accounts/${accountId}/quotes/${id}/bond-form`, data);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: bondRequestBondFormQueryKey(id) });
			queryClient.invalidateQueries({
				queryKey: bondRequestLatestUnderwritingQueryKey(id),
			});
		},
	});

	return {
		updateBondForm: mutation.mutate,
		updateBondFormIsLoading: mutation.isPending,
		updateBondFormError: mutation.error,
	};
};
